import { useEffect, useState } from 'react';
import { api } from '../../lib/api';

// Fetches the current user's forum rights so pages can show/hide the
// New Thread and Reply controls. Defaults to full access while loading.
export default function useForumAccess() {
  const [access, setAccess] = useState({
    level: 'full', can_view: true, can_post: true, can_reply: true,
    is_moderator: false, mod_perms: [], message: '',
  });
  useEffect(() => {
    let alive = true;
    api.get('/forum/my-access')
      .then(({ data }) => { if (alive && data) setAccess(data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return access;
}
